import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { SocialFeedService } from '../social-feed/services/social-feed.service';
import { CommunityLinkPreview } from '../social-feed/models/social-feed.model';
import { communityError } from '../community/community-utils';
import { SocialHubService } from '../social-feed/services/social-hub.service';

/** Someone opened an invite link: show the community, then join with one press. */
@Component({
  selector: 'app-community-join',
  templateUrl: './community-join.component.html',
  styleUrls: ['./community-join.component.scss'],
  standalone: false,
})
export class CommunityJoinComponent implements OnInit {
  token = '';
  preview: CommunityLinkPreview | null = null;
  loading = true;
  invalid = false;
  joining = false;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private social: SocialFeedService,
    private toaster: ToastService,
    private hub: SocialHubService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') || '';
    this.social.previewCommunityLink(this.token).subscribe({
      next: (preview) => {
        this.preview = preview;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.invalid = true;
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }

  join(): void {
    if (this.joining || !this.preview) return;
    if (this.preview.already_member) {
      this.router.navigate(['/communities', this.preview.community.slug]);
      return;
    }
    this.joining = true;
    this.error = '';
    this.social.joinCommunityByLink(this.token).subscribe({
      next: (community) => {
        this.hub.refreshCommunities();
        this.toaster.showSuccess(`Welcome to ${community.name}!`);
        this.router.navigate(['/communities', community.slug]);
      },
      error: (err) => {
        this.joining = false;
        this.error = communityError(err, "Couldn't join. Please try again.");
        this.cdr.detectChanges();
      },
    });
  }

  imageUrl(path: string | null | undefined): string {
    return this.social.resolveImageUrl(path);
  }

  initials(name: string): string {
    return (name || '')
      .split(/\s+/)
      .map((w) => w[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }
}
